import {SagaIterator} from "redux-saga";
import {Api, ApiError} from "modules/utils/Api";
import {fetchPlayersSuccess, fetchSquadsSuccess, showErrorModal} from "modules/actions";
import {call, put} from "typed-redux-saga";

export const fetchSquadsSaga = function* (): SagaIterator {
	try {
		const response = yield* call(Api.JSON.squads);
		ApiError.CHECK_JSON(response, "Error while loading squads");
		yield* put(fetchSquadsSuccess(response.data.squads));
	} catch (e) {
		const error = e as ApiError;
		yield* put(showErrorModal(error.message));
	}
};

export const fetchPlayersSaga = function* (): SagaIterator {
	try {
		const response = yield* call(Api.JSON.players);
		ApiError.CHECK_JSON(response, "Error while loading players");
		yield* put(fetchPlayersSuccess(response.data.players));
	} catch (e) {
		console.log(e);
	}
};
